import { getUrlParam } from "./urlParams";

const CompanyGUIDs = {
  Acqueon: "4E4D465D-B5E2-450A-A108-460866C8FA5E",
  "Allied Global": "0A1F947E-9047-4753-8148-CE8C51888C19",
  Alorica: "64932101-78C3-49F0-AC5A-9ADBCB7D3ED1",
  "Arise Virtual Solutions Inc.": "D2676968-C552-4319-A0F9-22ACF007E441",
  "Baylor Scott & White": "23BA978B-CD86-4036-9DBE-377E19A7AF76",
  Centurylink: "5296211B-24E7-44BC-AF7D-D56C7BA6F351",
  Chewy: "E6A45C48-CD30-427D-B620-8E14EC21C5B8",
  Cognizant: "696AB4BF-51DC-44BC-B44B-BEEFF416EC79",
  Connexus: "88D9D6E8-8E18-4843-B260-50352065BF6C",
  "Cox Communications": "EA8CD862-A156-4933-8E7A-99C8006D657F",
  Discover: "EC7C39D0-7157-4EEC-B05B-EA723D0216D4",
  FirstSource: "9455DCE0-3D53-4E94-8A64-5DE90F8713A9",
  "Go Daddy": "51841AF1-EA61-4091-9106-C461ED5293A8",
  HGS: "95EFCAE2-E364-4B8C-8919-26DDEE3A432B",
  "HGS - CES": "FD18D467-E040-493C-9D29-B217D7034D0F",
  Inspiro: "47B2938C-2213-40D1-AE82-647FF94C2C83",
  iQor: "1740DFCD-EFB4-4F97-BF9A-229E737C53C3",
  "Iterum Connections": "E15DDFB3-9D20-42A8-B66B-88E0C260E182",
  "Metro by T-Mobile": "C184CA55-7D40-4CAC-A62C-34CE2801A6BC",
  Movate: "902C2D60-F9F2-442B-83AE-020BF7E49DBA",
  Navient: "11E83259-E303-41BF-B9D3-89454D019B60",
  Nearsol: "3DC4E355-7B44-411E-A23F-88CC5CB8965F",
  Numeris: "72A81DA2-2ED8-40B4-BFCC-F602171C1C38",
  Omnicare365: "8B5285E6-AB35-43B9-AB86-53A594F750B8",
  Opendoor: "8148A3EB-063A-42BC-9C89-BBB4B5C128DA",
  Outworx: "A663C4F8-7177-4CB6-A9AD-3D30DC3E286C",
  "Premier Bank": "905F6761-FF6C-4731-80F3-811652FBAE20",
  "Royal Caribbean": "4E5C4C79-9F74-46DC-9D59-A81F2EE0B5FA",
  "Sonic Automotive Inc": "DC2F48F3-B829-4915-821E-D9DF3803F4BA",
  SSG: "94EA9A3D-74B8-499B-B8D4-7C80334BDA13",
  "SSM Health": "30111817-A4EB-46FA-9235-270F0342CCE5",
  "Sun Country Airlines": "639DC6CB-C255-482B-9584-F07E533DDDA7",
  Teleperformance: "CB0A635E-E09C-47FA-AEF6-581173FAC0FE",
  "Telus International": "C412D0CC-19A9-4123-B515-DF0087DEFFA7",
  THDBPO: "76E93134-B348-4062-862C-35E0B13574A6",
  "The Home Depot": "AFE20497-F14C-49B5-B6F5-E4D282708861",
  Thrasio: "D0BC5C73-5C9B-4442-B63C-BD8FE59DB4E3",
  Transcosmos: "F2E2DA7D-05D9-4285-8BAA-6936575E942A",
  TTEC: "0E925029-77F5-483D-A1EF-008CB0133FDE",
  "UM Health": "B276B3E0-ACD3-4759-981D-7D7A36858F18",
  Universal: "3D896A9C-7E50-4953-A0EF-5586BBD8E58E",
  "Voice Team": "0DDE4CD9-57B4-4274-94C9-7E4F4E55A60F",
  "Woodforest National Bank": "1934BF18-5E0C-4250-9203-8CF84A5994BA",
  UpWork: "DCEC5A25-94A9-4CA8-88FB-1FDE7BDE7CC6",
  "Ultra Mobile": "0DDE4CD9-57B4-4274-94C9-7E4F4E55A60F",
  Sutherland: "725D512D-44DC-4AEF-92F9-082A1DEB5AB6",
  "Authority Brands": "4946034B-F0E7-4D61-B121-692D3A3B0BA1",
  Amtrak: "31CF1EB2-2D8B-47E0-A9EA-B38FCA742BEF",
  "Prime Therapeutics": "8B3B54C8-11AF-42A4-941B-D0715B42B41E",
  "Global Industrial": "A7CBD222-23BA-433E-AB42-0CC02CEA63A1",
  Mohela: "568D75F9-F8E9-477D-A3A7-8EDC2E098830",
  "GoDaddy Historical": "A970D476-3A93-4D52-AEBB-CFFE93853B42",
  Fiserv: "BFA909F7-A459-40A0-AA6B-C789CF44A0C9",
  AON: "780A6BF5-5519-476B-91BB-15EEA8C39E64",
  InactiveB_Gos_Out: "2F0CF686-7705-4C63-9878-9FFF1BF7B949_Inactive",
  "NexGen Agency": "A60D618F-8FCC-4D37-BEDC-795DECE686E3",
  Velera: "FEA29F98-EA54-477B-9767-A080316CC0DD",
  "Teleperformance BOA": "CBA78C11-8738-41E4-A332-D0C30183B4DA",
  Milliman: "21860A92-12D2-49DE-9543-2FD75340B9BA",
  "Goosehead Insurance": "B2D52B08-A8FA-49DC-82A7-259890043AC0",
  SmartPak: "A69B2117-974A-468B-865C-D52070EA72D2",
  Datamark: "872F9103-326F-47C5-A3C2-566565F2F541",
  teleperformancesenture: "37F4E46A-024F-41EC-AA59-50B61149C062",
  "Canon ITS": "1F319366-769E-411B-82D1-BC802A8DD151",
  "Movate ATT": "3EBEC9FD-6C47-41E7-BE96-35F90E53AD94",
  Priceline: "44ABB2D8-CC02-4DBD-B851-20552387910B",
  "AVISO WEALTH": "F82132A9-C1E5-468E-8186-EC57094D4026",
  ADVENSUS: "C84F19D6-6307-40BC-A792-D1C398040CC3",
  "COX AUTOMOTIVE": "972D2E58-0BBD-438C-B0CE-61BC4A4E0708",
  KOBIE: "CEA27056-10DA-4D8F-A577-87840A8399D2",
  WHOOP: "EDA86111-D047-4B6E-A3A5-04AAC4827937",
  NEIGHBORLY: "9C051347-1D51-475E-9F5A-F4D21B98C6DE",
  TP: "8DAE3AF5-7018-4389-A1FD-253D8D416F0E",
  "AUTOMATED HEALTH SYSTEMS": "450AE5AF-D7D3-4F65-917D-3FF0F617676C",
  "BLUE STREAM FIBER": "EB790476-485A-45BE-99D1-414A728C97F9",
  HUMANA: "97BA2726-ECD4-47E9-BA1D-DA53A3132AF9",
  Percepta: "BBC6E60C-8ED9-40AD-93BD-BCC2F4A4E4F6",
  "Owens & Minor": "AB1CFC8C-3A15-46E9-830B-3554D6B2742A",
  "Acquity BPO": "91DDDC0F-1132-4422-BB65-F95E3DFF97BB",
  "CVS Health Retail": "258274E4-2624-4CD2-93DA-E8B00544AA2A",
  "Star Co": "7A34E253-382A-4A80-B73D-86E92250A238",
  "CVS Health Caremark": "158207FE-6530-4D8D-BB4F-3C5D05D30737",
  "CVS Health ISM": "A8BBB1E8-59F5-44B9-AD95-1B68B9EB44F1",
  "Community Choice Credit Union": "977DFDE0-64AF-4111-A1F7-5463E724287D",
  Covetrus: "1BB6DE89-8CAC-4022-8158-E4CFDEDB8939",
  "Pimlico Plumbers": "50399358-D5C2-4BD1-91A5-173E5361FF9F",
  "Blue Cross Blue Shield of Minnesota": "82134D53-A84F-4695-A465-BE08BF6660E5",
  "Henry Schein One, LLC": "2A7383F9-EF45-42BE-8244-106A6C08DED9",
  Centerfield: "B42431D6-47BF-4F47-BFD2-27C84F3514A8",
  "FIRST ADVANTAGE": "B3FBB6C2-4AAC-44AC-9687-F84829F5D0E2",
};
Object.freeze(CompanyGUIDs);
const urlCompanyGuid = getUrlParam("companyguid");
export const currentCompanyGuid =
  sessionStorage.getItem("currentCompany") || urlCompanyGuid;
// sessionStorage.removeItem("currentCompany");
export default CompanyGUIDs;
